import { Placeholders } from "..";

export const nodeExportLookupItemsEndpoint = `/api/${Placeholders.companyID}/lookupnodes/items`;
export const nodeExportLookupTemplatesEndpoint = `/api/${Placeholders.companyID}/lookupnodes/templates`;
export const nodeGroupsExportLookupEndpoint = `/api/${Placeholders.companyID}/lookupnodegroups`;
